'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _map2 = require('./internal/_map');

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new Iterable by applying `mapper` to each item in `subject`.
 *
 * @example
 * // returns List [ 2, 3, 4 ]
 * map(
 *   (val) => val + 1,
 *   List.of(1, 2, 3)
 * );
 *
 * @param  {Function} mapper applied to each item in `subject`.
 * @param  {Iterable} subject the Iterable to map.
 * @return {Iterable} with each value of `subject` updated with mapper.
 */
exports.default = (0, _curry2.default)(_map3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/map.js
// module id = 376
// module chunks = 0 1